<template>
  <div class="ui-wrap">
    <div class="ui-box">
      <div class="top">
        <p class="title">
          <!-- {{ isTeacher ? $t('common.teacher') : $t('common.student') }} -->
          {{ $t('newRegister') }}
        </p>
        <div class="right">
          <!-- <label
            class="checkbox"
            :class="{ checked: type === 0 }"
            @click="type = 0"
            >{{ $t('phone') }}</label
          > -->
          <!-- <label
            class="checkbox"
            :class="{ checked: type === 1 }"
            @click="type = 1"
            >{{ $t('email') }}</label
          > -->
        </div>
      </div>
      <div class="regist">
        <template v-if="type === 0">
          <div class="ipt">
            <input
              class="regist-ipt"
              type="text"
              @change="changeNo"
              v-model="mobileNO"
              @focus="clearError(0)"
              :placeholder="$t('inputPhone')"
            />
            <div class="pre-num">
              <el-select
                class="preCode"
                @change="changeNo"
                v-model="value"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in countryList"
                  :key="item.countryCode"
                  :label="item.photoCode"
                  :value="item.photoCode"
                >
                </el-option>
              </el-select>
            </div>
            <p class="ui-error" v-if="errorArr[0]">
              {{ $t('register.phone') }}
            </p>
          </div>
          <smscode
            :info="info"
            :error="errorArr[1]"
            :ipt="info.mobileNO"
            @clearError="clearError(1)"
            @setError="errorArr.splice(0, 1, 1)"
          ></smscode>
        </template>
        <div class="ipt" v-else>
          <input
            class="regist-ipt"
            type="text"
            v-model="info.email"
            :placeholder="$t('inputEmail')"
            @focus="clearError(2)"
          />
          <span class="pre-icon2"></span>
          <p class="ui-error" v-if="errorArr[2]">{{ $t('register.email') }}</p>
          <smscode
            :info="info"
            :error="errorArr[1]"
            :ipt="info.email"
            @clearError="clearError(1)"
            @setError="errorArr.splice(2, 1, 1)"
          ></smscode>
        </div>
        <!-- 新增修改部分-->
        <div class="firstname">
          <input
            class="regist-ipt"
            type="text"
            v-model="info.firstName"
            :placeholder="$t('placeholderFirstName')"
            @focus="clearError(5)"
          />
          <p class="ui-error" v-if="errorArr[5]">{{ $t('name') }}</p>
        </div>
        <div class="surname">
          <input
            class="regist-ipt"
            type="text"
            v-model="info.lastName"
            :placeholder="$t('placeholderSurname')"
            @focus="clearError(4)"
          />
          <p class="ui-error" v-if="errorArr[4]">{{ $t('surname') }}</p>
        </div>

        <!-- <div class="linkEmail">
          <input class="regist-ipt" type="text" v-model="info.linkEmail" :placeholder="$t('placeholderLinkEmail')" />
          <p class="ui-error" v-if="errorArr[6]">{{ $t('linkEmail') }}</p>
        </div> -->
        <div class="linkMobileNo">
          <input
            class="regist-ipt"
            type="text"
            v-model="info.linkMobileNo"
            :placeholder="$t('placeholderLinkMobileNo')"
          />
        </div>
        <!--  -->
        <div class="psw">
          <input
            type="password"
            class="regist-ipt"
            v-model="info.pwd"
            @focus="clearError(3)"
            :placeholder="$t('inputpswd')"
          />
          <p class="ui-error" v-if="errorArr[3] === 1">
            {{ $t('register.pwd1') }}
          </p>
          <p class="ui-error" v-if="errorArr[3] === 2">
            {{ $t('register.pwd2') }}
          </p>
        </div>
        <div class="psw">
          <input
            type="password"
            class="regist-ipt"
            v-model="info.pwd2"
            @focus="clearError(3)"
            :placeholder="$t('common.again')"
          />
        </div>
        <div class="row">
          <label
            class="checkbox"
            @click="info.isSign = info.isSign == 1 ? 0 : 1"
            :class="{ checked: info.isSign == 1 }"
            >{{ $t('accept') }}</label
          >
          <a @click="show = true" class="terms">{{ $t('term') }}</a>
        </div>
        <a class="ui-btn" @click="register">{{ $t('create') }}</a>
        <router-link class="goLogin" to="/login">{{ $t('login') }}</router-link>
        <!-- <Other></Other> -->
      </div>
    </div>
    <term :show="show"></term>
    <!-- <el-dialog :visible.sync="regSuccess" width="100%">
      <img
        class="adv-img"
        v-if="$i18n.locale === 'en'"
        src="../assets/registration success_ENg.png"
        width="100%"
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'cn'"
        src="../assets/registration success_SCN.png"
        width="100%"
      />
      <img
        class="adv-img"
        v-if="$i18n.locale === 'TW'"
        src="../assets/registration success_TCN.png"
        width="100%"
      />
    </el-dialog> -->
  </div>
</template>
<script>
import Other from '@/components/OtherLogin.vue'
import smscode from '@/components/Smscode.vue'
import term from '@/components/PopTerm.vue'
import {
  regUserByMobileNO,
  regUserByEmail,
  getAccessToken,
  login
} from '@/service/loginAndRegistApi.js'
// 学生注册
import { regStudentByEmail, regStudentByMobile } from '@/service/studentApi.js'
// 老师注册
import { regTeacherByEmail, regTeacherByMobile } from '@/service/teacherApi.js'

import {
  getCountryList,
  // 验证码
  verifyEmailCode,
  verifySmsCode,
  verifyExist,
} from '@/service/api.js'
// import { delete } from 'vue/types/umd'
export default {
  components: { Other, smscode, term },
  data() {
    return {
      info: {
        mobileNO: '',
        email: '',
        smsCode: '',
        time: '',
        checksum: '',
        userType: '',
        pwd: '',
        pwd2: '',
        isSign: 1,
        // 新增部分
        lastName: '',
        firstName: '',
        linkMobileNo: '',
        // linkEmail:'',
      },
      type: 1,
      errorArr: [0, 0, 0, 0, 0, 0],
      countryList: [],
      value: '+852',
      mobileNO: '',
      show: false,
      // regSuccess:false,
    }
  },
  watch: {

  },
  methods: {
    async register() {
      let state = true
      if (this.type === 0) {
        if (this.info.mobileNO.length === 0) {
          this.errorArr[0] = 1
          state = false
        }
        if (this.info.smsCode.length === 0) {
          this.errorArr[1] = 1
          state = false
        }
      } else {
        if (this.info.email.length === 0) {
          this.errorArr[2] = 1
          state = false
        }
      }
      // 新增部分
      if (this.info.lastName.length === 0) {
        this.errorArr[4] = 1
        state = false
      }
      if (this.info.firstName.length === 0) {
        this.errorArr[5] = 1
        state = false
      }
      if (this.info.pwd.length === 0) {
        this.errorArr[3] = 1
        state = false
      } else if (this.info.pwd !== this.info.pwd2) {
        this.errorArr[3] = 2
        state = false
      }
      this.$forceUpdate()
      if (state) {
        if (this.isTeacher) {
          this.info.userType = 20
        } else {
          this.info.userType = 10
        }

        if (this.type === 1) {
          // 判断邮箱是否被注册
          let resExist = await verifyExist({ email: this.info.email })
          if (resExist.data.status === 1) {
            if (resExist.data.isExist) {
              this.$message.error(this.$t('common.emailIsExist'))
              return false
            }
          }
          let obj = {
            email: this.info.email,
            smsCode: this.info.smsCode,
            time: this.info.time,
            checksum: this.info.checksum,
            pwd: this.info.pwd,
            pwd2: this.info.pwd2,
            lastName: this.info.lastName,
            firstName: this.info.firstName,
            mobileNO: this.info.linkMobileNo,
            // linkEmail:this.info.linkEmail,
          }
          let res
          // if (this.isTeacher) {
          //   res = await regTeacherByEmail(obj)
          // } else {
          //   res = await regStudentByEmail(obj)
          // }


          res = await regStudentByEmail(obj)
          // console.log(res.data.status);
          if (res.data.status === 1) {
            let res3 = await login({ account: this.info.email, pwd: this.info.pwd })
            if (res3.data.status === 1) {
              sessionStorage.setItem('1to1token', res.data.token)
              // let res2 = await getAccessToken()
              // if (res2.data.status === 1) {
              //   sessionStorage.setItem('token3rd', res2.data.data.token3rd)
              // }
            }
            if (this.isTeacher) {
              this.$router.push({
                path: '/teacherFill',
                query: { type: 0, obj: JSON.stringify(obj) },
              })
            } else {
              let user = {
                loginState: true,
                userType: 10,
                uid: this.user.uid,
                userName: this.info.firstName + this.info.lastName,
                userPhoto: this.info.userPhotoUrl,
              }
              this.$store.dispatch('SETUSER', user)
              if (document.body.clientWidth >= 768) {
                this.$message({
                  type: 'success',
                  message: this.$t('common.regSuccess'),
                })
                this.$router.push({ path: '/home' })
              } else {
                // this.$message({
                //   type: 'success',
                //   message: this.$t('common.phoneUpdateSuccess'),
                //   duration: 6000,
                // })
                // this.regSuccess=true;
                this.$router.push({ path: '/home',query: { regMsgShow:true}});
              }
              // this.$router.push({ path: '/home' })
              // this.$router.push({
              //   path: '/studentFill',
              //   query: { type: 0, obj: JSON.stringify(obj) },
              // })
            }
            // sessionStorage.setItem('1to1token', res.data.token)
            // let res2 = await getAccessToken()
            // if (res2.data.status === 1) {
            //   sessionStorage.setItem('token3rd', res2.data.data.token3rd)
            // }
          }
        } else {
          // 判断手机是否被注册
          let resExist = await verifyExist({ mobileNO: this.info.mobileNO })
          if (resExist.data.status === 1) {
            if (resExist.data.isExist) {
              this.$message.error(this.$t('common.phoneIsExist'))
              return false
            }
          }
          let obj = {
            mobileNO: this.info.mobileNO,
            smsCode: this.info.smsCode,
            time: this.info.time,
            checksum: this.info.checksum,
            pwd: this.info.pwd,
            pwd2: this.info.pwd2,
          }
          // this.info.mobileNO = this.value + this.info.mobileNO
          let res
          res = await verifySmsCode(obj)
          if (res.data.status === 1) {
            // let user = { loginState: false }
            // user.userType = res.data.userType
            // user.uid = res.data.uid
            // user.mobileNO = res.data.mobileNO
            // this.$store.dispatch('SETUSER', user)
            if (this.isTeacher) {
              this.$router.push({
                path: '/teacherFill',
                query: { type: 0, obj: JSON.stringify(obj) },
              })
            } else {
              this.$router.push({
                path: '/studentFill',
                query: { type: 0, obj: JSON.stringify(obj) },
              })
            }
            // sessionStorage.setItem('1to1token', res.data.token)
            // let res2 = await getAccessToken()
            // if (res2.data.status === 1) {
            //   sessionStorage.setItem('token3rd', res2.data.data.token3rd)
            // }
          }
        }
      }
    },
    changeNo() {
      // console.log('value'+this.value);
      // console.log('mobileNO'+this.info.mobileNO);
      this.info.mobileNO = ''
      this.info.mobileNO = this.value + this.mobileNO
      this.$forceUpdate()
    },
    clearError(n) {
      this.errorArr.splice(n, 1, 0)
    },
    async getCountryList() {
      const res = await getCountryList()
      if (res.data.status === 1) {
        this.countryList = res.data.data

        for (let i = 0; i < this.countryList.length; i++) {
          if (
            !!this.countryList[i].photoCode &&
            parseInt(this.countryList[i].photoCode) !== 0
          ) {
            this.countryList[i].photoCode =
              '+' + parseInt(this.countryList[i].photoCode)
          }
        }
        this.countryList = this.countryList
          .sort((a1, b1) => {
            let a = a1.photoCode
            let b = b1.photoCode
            if (a < b) return -1
            if (a > b) return 1
            return 0
          })
          .filter((item) => item.photoCode !== '' && item.photoCode !== '+0')
      }
    },
  },
  created() {
    this.getCountryList()
  },
  computed: {
    isTeacher() {
      return this.$route.query.type == 1
    },
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  display: flex;
  margin: 0 80px;
  border-bottom: 1px solid #d9d9d9;
  padding: 40px 12px 25px;
  line-height: 26px;
  .title {
    font-size: 24px;
    flex: 1;
  }
  .checkbox {
    margin-left: 30px;
  }
}
.regist {
  width: 520px;
  margin: 0 auto;
  padding: 30px 0 160px;
  .ui-btn {
    margin-top: 32px;
    display: block;
  }
}
.regist-ipt {
  width: 100%;
  height: 42px;
  border-radius: 42px;
  background: #ededed;
  border: 1px solid #ededed;
  padding: 10px 22px 10px 70px;
  line-height: 20px;
  &:focus {
    border-color: #002147;
  }
}
.ipt {
  position: relative;
}
.pre-num,
.pre-icon {
  position: absolute;
  top: 1px;
  left: 1px;
}
.pre-icon2 {
  position: absolute;
  left: 20px;
  top: 10px;
  width: 20px;
  height: 20px;
  background: url(../assets/email.png) no-repeat center center;
  background-size: 20px auto;
}
.code {
  margin-top: 30px;
  position: relative;
  .getCode,
  .time {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 32px;
    background: #002147;
    border-radius: 32px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    padding: 0 20px;
    min-width: 100px;
  }
  .time {
    background: #a0a0a0;
  }
  .regist-ipt {
    padding: 10px 120px 10px 70px;
    background: #ededed url(../assets/phone3.png) no-repeat 23px center;
  }
}
.surname {
  margin-top: 30px;
  .regist-ipt {
    background: #ededed url(../assets/surname.png) no-repeat 23px center;
    background-size: 15px auto;
  }
}
.firstname {
  margin-top: 30px;
  .regist-ipt {
    background: #ededed url(../assets/firstname.png) no-repeat 23px center;
    background-size: 15px auto;
  }
}
.linkMobileNo {
  margin-top: 30px;
  .regist-ipt {
    background: #ededed url(../assets/phone3.png) no-repeat 23px center;
  }
}
.linkEmail {
  margin-top: 30px;
  .regist-ipt {
    background: #ededed url(../assets/email.png) no-repeat 23px center;
    background-size: 20px auto;
  }
}
.psw {
  margin-top: 30px;
  .regist-ipt {
    background: #ededed url(../assets/psw.png) no-repeat 23px center;
  }
}
.row {
  overflow: hidden;
  line-height: 16px;
  height: 16px;
  margin-top: 17px;
}
.checkbox {
  font-size: 12px;
  color: #999;
  height: 16px;
  line-height: 16px;
  cursor: pointer;
  display: inline-block;
  &:before {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: top;
    margin: 1px 5px 0 0;
    border: 2px solid #767676;
    border-radius: 50%;
  }
  &.checked {
    &:before {
      background: url(../assets/gou.png);
      border: 0;
    }
  }
}
.terms {
  font-size: 12px;
  margin-left: 5px;
  color: #002147;
  text-decoration: underline;
}
.goLogin {
  display: block;
  line-height: 19px;
  text-align: center;
  margin-top: 30px;
  color: #002147;
  &:hover {
    color: lighten(#002147, 10%);
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .top {
    margin: 0 20px;
    display: block;
    .title {
      width: 100%;
      font-size: 16px;
      font-weight: bold;
    }
    .checkbox {
      // width: 100%;
      margin-top: 20px;
      margin-left: 10px;
    }
  }
  .ui-wrap {
    padding: 0;
  }
  .ui-wrap {
    margin: 0;
  }
  .ui-box {
    width: 100%;
  }
  .regist {
    width: 100%;
    padding: 0 20px;
    margin: 20px 0;
  }
  .goLogin {
    display: none;
  }
}
</style>
<i18n>
{
  "cn": {
    "newRegister":"家长/学生注册",
    "placeholderSurname":"输入您的姓",
    "placeholderFirstName":"输入您的名",
    "placeholderLinkEmail":"输入您的联系邮件",
    "placeholderLinkMobileNo":"手机号码（选填）- 只用于 WhatsApp",
    "surname":"姓氏不能为空",
    "name":"名字不能为空",
    "linkEmail":"联系邮件不能为空",
    "phone": "手机注册",
    "email": "邮箱注册",
    "inputpswd": "输入密码（8～20位字母、数字或特殊字符）",
    "accept": "接受",
    "term": "条款及细则",
    "create": "创建帐号",
    "login": "已有帐号，立即登录",
    "inputPhone": "输入手机号作为登录帐号",
    "inputEmail": "输入邮箱作为登录帐号"
  },
  "TW": {
    "newRegister":"家長/學生注冊",
    "placeholderSurname":"輸入您的姓",
    "placeholderFirstName":"輸入您的名",
    "placeholderLinkEmail":"輸入您的聯系郵件",
    "placeholderLinkMobileNo":"手機號碼（選填）- 只用於 WhatsApp",
    "surname":"姓氏不能為空",
    "name":"名字不能為空",
    "linkEmail":"聯系郵件不能為空",
    "phone": "手機註冊",
    "email": "郵箱註冊",
    "inputpswd": "輸入密碼（8～20位字母、數字或特殊字符）",
    "accept": "接受",
    "term": "條款及細則",
    "create": "創建帳號",
    "login": "已有帳號，立即登入",
    "inputPhone": "輸入手機號作為登錄帳號",
    "inputEmail": "輸入郵箱作為登錄帳號"
  },
  "en": {
    "newRegister":"PARENT/STUDENT REGISTRATION",
    "placeholderSurname":"Enter your last name",
    "placeholderFirstName":"Enter your first name",
    "placeholderLinkEmail":"Enter your link email",
    "placeholderLinkMobileNo":"Mobile no. (optional) - for WhatsApp only",
    "surname":"Last name cannot be empty",
    "name":"Name cannot be empty",
    "linkEmail":"Contact Email cannot be empty",
    "phone": "Register by mobile no.",
    "email": "Register by email",
    "inputpswd": "Password (Any 8-20 letters, numbers or symbols) ",
    "accept": "I accept the ",
    "term": "Terms and Conditions",
    "create": "Create account ",
    "login": "Already registered? Please login here",
    "inputPhone": "Enter mobile phone no. as your login name",
    "inputEmail": "Enter email address as your login name "
  }
}
</i18n>